__turbopack_context__.v({
  "addToCart": "VH6jTW_addToCart",
  "attrContainer": "VH6jTW_attrContainer",
  "details": "VH6jTW_details",
  "drawerButton": "VH6jTW_drawerButton",
  "modal": "VH6jTW_modal",
  "price": "VH6jTW_price",
  "root": "VH6jTW_root",
  "size": "VH6jTW_size",
  "sizeDisabled": "VH6jTW_sizeDisabled",
  "sizeSelected": "VH6jTW_sizeSelected",
  "sizeSelector": "VH6jTW_sizeSelector",
  "specs": "VH6jTW_specs",
  "title": "VH6jTW_title",
  "titleContainer": "VH6jTW_titleContainer",
});
